
import { Component, Vue } from 'vue-property-decorator'
import { SelectOption } from '@/components/common/atoms/SelectBase.vue'

/** ヘルプグループ型 */
export type helpGroupApiType = {
  id: number
  name: string
  sortNum: number
}

/** 集計種別型 */
export type summaryTypeApiType = {
  id: number
  name: string
  code: string
  sortNum: number
}

/**
 * SelectOptionsの共通化
 */
@Component
export default class SelectOptionsApis extends Vue {
  /**
   * ヘルプグループ一覧取得
   */
  protected async helpGroupSelectOptionsApi(): Promise<SelectOption[]> {
    try {
      const { data }: { data: helpGroupApiType[] } = await Vue.prototype.$http.httpWithToken.get('/v1/help_groups')

      return data.map((obj: helpGroupApiType) => {
        return { value: obj.id, text: obj.name } as SelectOption
      })
    } catch (_error: any) {
      return []
    }
  }

  /**
   * 集計種別一覧取得
   */
  protected async summaryTypeSelectOptionsApi(): Promise<SelectOption[]> {
    try {
      const { data }: { data: summaryTypeApiType[] } = await Vue.prototype.$http.httpWithToken.get('/v1/summary_types')

      return data.map((obj: summaryTypeApiType) => {
        return { value: obj.code, text: obj.name } as SelectOption
      })
    } catch (_error: any) {
      return []
    }
  }
}
